import { render, staticRenderFns } from "./TabRelationship.vue?vue&type=template&id=07898649&scoped=true&"
import script from "./TabRelationship.vue?vue&type=script&lang=js&"
export * from "./TabRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07898649",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07898649')) {
      api.createRecord('07898649', component.options)
    } else {
      api.reload('07898649', component.options)
    }
    module.hot.accept("./TabRelationship.vue?vue&type=template&id=07898649&scoped=true&", function () {
      api.rerender('07898649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabRelationship.vue"
export default component.exports